import React, { useEffect } from 'react';
import styled from 'styled-components';
import { JRCIcon } from '../../JRCIcon/JRCIcon';

export const CSSCheckboxWrapper = styled.button`
    border: 1px solid ${(props) => props.theme.color.grey2};
    background-color: ${(props) => props.theme.color.grey1};
    width: 24px;
    height: 24px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const EditorCheckbox = ({
    initialValue = false,
    isDisabled,
    onChange,
}: {
    initialValue: boolean | undefined;
    isDisabled?: boolean;
    onChange: (status: boolean) => void;
}) => {
    const [isChecked, setIsChecked] = React.useState<boolean>(initialValue);

    useEffect(() => {
        if (initialValue !== isChecked) {
            setIsChecked(initialValue);
        }
    }, [initialValue, isChecked]);

    return (
        <CSSCheckboxWrapper
            onClick={() => {
                if (!isDisabled) {
                    onChange(!isChecked);
                }
            }}>
            {isChecked ? <JRCIcon name="icon-check" size={12}></JRCIcon> : <></>}
        </CSSCheckboxWrapper>
    );
};
